// extracted by mini-css-extract-plugin
module.exports = {"root":"table-footer_root__2vo8z"};